export const PAGE_TYPES = {
  tech: 'tech',
  website: 'website',
  blog: 'article',
  solution: 'solution',
} as const;

export type PageType = typeof PAGE_TYPES[keyof typeof PAGE_TYPES];

export type Page = {
  id: string;
  name: string;
  type: PageType;
  image?: string;
  description?: string;
  createdAt?: string;
  modifiedAt?: string;
};

// Se quiser uma lista para iterar (ex.: select)
export const PAGE_TYPE_LIST: PageType[] = Object.values(PAGE_TYPES);
